module.exports = __webpack_public_path__ + "static/img_03-9c510061b897586b09665e75d2d100d0.png";